<template>
    <tr class="stage stage_row">
        <StageName
            v-if="isAccessAllow"
            :stage="stage"
            @update="stageName => $emit('updateStage', stage.set('name', stageName, true))"
            @delete="$emit('deleteStage')"
        />
        <td v-else class="stage__col stage__col_name">
            <span class="stage-name-label__text text-truncate mr-1">{{ stage.name }}</span>
        </td>
        <StageRelated
            v-if="isAccessAllow"
            :stages="stages"
            :stage="stage"
            @update="relatedStageId => $emit('updateStage', stage.setRelatedId(relatedStageId, stages, true))"
        />
        <td v-else class="stage__col stage__col_related">
            <div>{{ stage.name || 'Нет' }}</div>
        </td>
        <StageResponsible
            v-if="isAccessAllow"
            :responsibleUserId="stage.responsible"
            @update="responsibleId => $emit('updateStage', stage.set('responsible', responsibleId, true))"
        />
        <td v-else class="stage__col stage__col_responsible">
          <div>{{ getResponsible() }}</div>
        </td>
        <td class="stage__col stage__col_date-start">
            <Calendar
                v-if="stage.dateStart && hasAccess"
                :value="stage.dateStart"
                @input="dateStart => $emit('updateStage', stage.set('dateStart', dateStart, true))"
            />
            <span v-else-if="stage.dateStart">{{ formattedDate(stage.dateStart) }}</span>
            <span v-else>не задано</span>
        </td>
        <td class="stage__col stage__col_date-finish">
            <Calendar
                v-if="stage.dateFinish && hasAccess"
                :value="stage.dateFinish"
                @input="dateFinish => $emit('updateStage', stage.set('dateFinish', dateFinish, true))"
                :minDate="stage.dateStart || null"
            />
            <span v-else-if="stage.dateFinish">{{ formattedDate(stage.dateFinish) }}</span>
            <span v-else>не задано</span>
        </td>
        <td class="stage__col stage__col_status">
            <Select
                v-if="hasAccess"
                name="statuses"
                :items="stage.statuses"
                :active="stage.status"
                @selectChange="statusId => $emit('updateStage', stage.set('status', statusId, true))"
            />
            <span v-else>{{ stage.statuses.find(s => +s.id === stage.status)?.label || 'не выбран' }}</span>
        </td>
    </tr>
</template>

<script>
import {mapState} from "vuex";
import Calendar from "@common/vue/components/form/Calendar";
import {dateToDMY} from "@common/utils/date";
import StageName from "@/vue/plan/input/StageName";
import StageRelated from "@/vue/plan/input/StageRelated";
import StageResponsible from "@/vue/plan/input/StageResponsible";
import PlanStageModel from "@/vue/plan/model/PlanStageModel";

export default {
    name: "SubtaskStage",
    components: {Calendar, StageResponsible, StageRelated, StageName},
    props: {
        stage: {
            validator: (stage) => PlanStageModel === stage.constructor,
        },
        isAccessAllow: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        ...mapState({
            stages: state => state.planUrl.selectedStreamStages,
            users: state => state.planUrlTask.users,
            authUser: state => state.common.authUser,
        }),
        hasAccess() {
            return this.isAccessAllow || this.authUser.id === this.stage.responsible;
        },
    },
    methods: {
        formattedDate(date) {
            return dateToDMY(date);
        },
        getResponsible() {
            const responsible = this.users.find(u => u.id === this.stage.responsible);
            return responsible ? this.responsibleLabel(responsible) : 'Не выбран';
        },
        responsibleLabel(user) {
            return `${user.lastname || ''} ${user.firstname || ''}` ;
        },
    },
}
</script>
